import React from 'react'
import Heading from 'components/heading';

const NotFound = () => {
  return (
    <div>
        <Heading text={'NotFound'}/>
    </div>
  )
}

export default NotFound;